import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'

export const formFilter: {
    input?: InputBuildProps
    select?: SelectBuildProps
    layout?: any
}[] = [
        {
            select: {
                id: 'baseConsulta',
                label: 'Base de consulta:',
                options: [
                    { text: 'Detran', value: 'DETRAN' },
                    { text: 'SNG', value: 'SNG' }
                ],
                required: true
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            select: {
                id: 'ufContrato',
                label: 'UF do contrato:',
                optionsType: 'ufSearchContract',
                required: true
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'cnpjAgenteFinanceiro',
                label: 'CNPJ Agente Financeiro',
                maskReplace: 'cnpj'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'chassi',
                label: 'N° Chassi'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'cpfCnpjDevedor',
                label: 'CPF/CNPJ Devedor',
                maskReplace: 'registro'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            select: {
                id: 'tipoRestricao',
                label: 'Tipo de restrição',
                optionsType: 'type'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'numeroContrato',
                label: 'N° Contrato'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'numeroAditivo',
                label: 'N° Aditivo'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'numeroDuda',
                label: 'N° Duda'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'numeroGravame',
                label: 'N° do Gravame'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'numeroRestricao',
                label: 'N° da Restrição'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'dataEnvioInicial',
                label: 'Período de envio',
                type: 'date'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
    ]